import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';

import { EmployerStateType } from 'src/models/negotiationTopic.types';

const UPDATE_ENABLED = 'UPDATE_ENABLED';
const UPDATE_CONFIGURABLE_SETTINGS = 'UPDATE_CONFIGURABLE_SETTINGS';
const UPDATE_AI_ASSISTANT_HR = 'UPDATE_AI_ASSISTANT_HR';

export type TargetTopicEmployerState =
    | EmployerStateType.PhoneInterview
    | EmployerStateType.Interview
    | EmployerStateType.Response
    | EmployerStateType.Consider
    | EmployerStateType.Offer
    | EmployerStateType.Hired;

export interface AIAssistantHrSettings {
    questions: string[];
    additionalContext: string;
    targetTopicEmployerState: TargetTopicEmployerState;
}

export type RuleId = number;

export type AIAssistantHR = {
    configurableSettings: AIAssistantHrSettings;
} & (
    | {
          ruleId: RuleId;
          enabled: boolean;
      }
    | {
          ruleId: null;
          enabled: false;
      }
);

interface PayloadTypes {
    [UPDATE_ENABLED]: boolean;
    [UPDATE_CONFIGURABLE_SETTINGS]: Partial<AIAssistantHrSettings>;
    [UPDATE_AI_ASSISTANT_HR]: AIAssistantHR;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();

export const updateEnabled = actionCreator(UPDATE_ENABLED);
export const updateConfigurableSettings = actionCreator(UPDATE_CONFIGURABLE_SETTINGS);
export const updateAIAssistantHR = actionCreator(UPDATE_AI_ASSISTANT_HR);

const INITIAL_STATE: AIAssistantHR = {
    ruleId: null,
    enabled: false,
    configurableSettings: {
        questions: [],
        additionalContext: '',
        targetTopicEmployerState: EmployerStateType.PhoneInterview,
    },
};

const aiAssistantHR = createReducer<AIAssistantHR, PayloadTypes>(INITIAL_STATE, {
    [UPDATE_ENABLED]: (state, action) => {
        if (!state.ruleId) {
            return { ...state };
        }

        return {
            ...state,
            enabled: action.payload,
        };
    },
    [UPDATE_CONFIGURABLE_SETTINGS]: (state, action) => {
        return {
            ...state,
            configurableSettings: { ...state?.configurableSettings, ...action.payload },
        };
    },
    [UPDATE_AI_ASSISTANT_HR]: (state, action) => {
        return {
            ...state,
            ...action.payload,
        };
    },
});
export { aiAssistantHR };
